export const CLASES_ESCRITO = [
    // Actos administrativos EXTERNOS a la fiscalía (autoridad) — se incorporan
    // digitalizados, no se redactan en el sistema.
    'decreto_instruye_sumario',
    'acto_administrativo',
    // Familia A — resoluciones de fiscalía (internas)
    'resolucion_acepta_cargo',
    'resolucion_constituye_fiscalia',
    'resolucion_incorpora_antecedentes',
    'resolucion_solicita_antecedentes',
    'resolucion_solicita_oficio_externo',
    'resolucion_solicita_comparecencia',
    'resolucion_suspension_preventiva',
    'resolucion_medidas_resguardo_karin',
    'resolucion_solicita_peritaje',
    'informe_diligencia',
    'acta_declaracion',
    'formulario_denuncia',
    'resolucion_eleva_autos_recusacion',
    'resolucion_reapertura',
    'resolucion_pide_acumular',
    'resolucion_acumula_autos',
    'resolucion_incorpora_analisis_fiscalia',
    'resolucion_cierra_instruccion',
    'resolucion_sobreseimiento',
    'resolucion_formula_cargos',
    'resolucion_provee_escrito',
    'resolucion_evacuados_descargos',
    'resolucion_termino_probatorio',
    'vista_fiscal',
    'resolucion_cierra_procedimiento',
    'constancia_notificacion',
    // Familia B — escritos de parte (inculpado/defensa)
    'escrito_descargos',
    'solicitud_recusacion',
    'solicitud_nulidad',
    'solicitud_aumento_plazo',
    'solicitud_copia_expediente',
    // Familia anexo — antecedentes de terceros incorporados como prueba
    'correo_electronico',
];
export const DEFINICION_CLASE_ESCRITO = {
    decreto_instruye_sumario: {
        clase: 'decreto_instruye_sumario',
        nombre: 'Decreto/Resolución que instruye el sumario (autoridad)',
        familia: 'fiscalia',
        etapaTypica: ['creado'],
        orden: 1,
        esMinimaEsperable: true,
    },
    acto_administrativo: {
        clase: 'acto_administrativo',
        nombre: 'Acto administrativo de la autoridad (decreto / resolución exenta)',
        familia: 'fiscalia',
        etapaTypica: ['creado', 'instruccion', 'formulacion_cargos', 'vista_fiscal', 'cerrado'],
    },
    resolucion_acepta_cargo: {
        clase: 'resolucion_acepta_cargo',
        nombre: 'Acepta cargo (fiscal y actuario)',
        familia: 'fiscalia',
        etapaTypica: ['creado'],
        orden: 3,
        esMinimaEsperable: true,
    },
    resolucion_constituye_fiscalia: {
        clase: 'resolucion_constituye_fiscalia',
        nombre: 'Constituye fiscalía',
        familia: 'fiscalia',
        etapaTypica: ['creado'],
        orden: 3,
    },
    resolucion_incorpora_antecedentes: {
        clase: 'resolucion_incorpora_antecedentes',
        nombre: 'Incorpora antecedentes al expediente',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 6,
    },
    resolucion_solicita_antecedentes: {
        clase: 'resolucion_solicita_antecedentes',
        nombre: 'Solicita antecedentes a unidad interna',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 6,
        esMinimaEsperable: true,
    },
    resolucion_solicita_oficio_externo: {
        clase: 'resolucion_solicita_oficio_externo',
        nombre: 'Oficia a organismo externo (certificaciones/información)',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 6,
    },
    resolucion_solicita_comparecencia: {
        clase: 'resolucion_solicita_comparecencia',
        nombre: 'Cita a declarar / formulación de causales de recusación',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 4,
        esMinimaEsperable: true,
    },
    resolucion_suspension_preventiva: {
        clase: 'resolucion_suspension_preventiva',
        nombre: 'Suspensión preventiva',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 4,
    },
    resolucion_medidas_resguardo_karin: {
        clase: 'resolucion_medidas_resguardo_karin',
        nombre: 'Medidas de resguardo (Ley Karin)',
        familia: 'fiscalia',
        etapaTypica: ['creado', 'instruccion'],
        orden: 17,
        esMinimaEsperable: true,
    },
    resolucion_solicita_peritaje: {
        clase: 'resolucion_solicita_peritaje',
        nombre: 'Ordena peritaje o diligencia técnica',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 6,
    },
    informe_diligencia: {
        clase: 'informe_diligencia',
        nombre: 'Informe de diligencia / peritaje',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 6,
    },
    acta_declaracion: {
        clase: 'acta_declaracion',
        nombre: 'Acta de declaración',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 5,
        esMinimaEsperable: true,
    },
    formulario_denuncia: {
        clase: 'formulario_denuncia',
        nombre: 'Formulario de denuncia (Ley Karin)',
        familia: 'anexo',
        etapaTypica: ['creado', 'instruccion'],
    },
    resolucion_eleva_autos_recusacion: {
        clase: 'resolucion_eleva_autos_recusacion',
        nombre: 'Eleva autos a la autoridad por recusación',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 14,
    },
    resolucion_reapertura: {
        clase: 'resolucion_reapertura',
        nombre: 'Reapertura del procedimiento',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 14,
    },
    resolucion_pide_acumular: {
        clase: 'resolucion_pide_acumular',
        nombre: 'Pide acumular autos',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 14,
    },
    resolucion_acumula_autos: {
        clase: 'resolucion_acumula_autos',
        nombre: 'Acumula autos (otro sumario)',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 14,
    },
    resolucion_incorpora_analisis_fiscalia: {
        clase: 'resolucion_incorpora_analisis_fiscalia',
        nombre: 'Incorpora resumen/análisis de la fiscalía',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 7,
    },
    resolucion_cierra_instruccion: {
        clase: 'resolucion_cierra_instruccion',
        nombre: 'Cierra la etapa de instrucción',
        familia: 'fiscalia',
        etapaTypica: ['instruccion'],
        orden: 7,
        esMinimaEsperable: true,
    },
    resolucion_sobreseimiento: {
        clase: 'resolucion_sobreseimiento',
        nombre: 'Sobresee a un inculpado',
        familia: 'fiscalia',
        etapaTypica: ['formulacion_cargos', 'sobreseido'],
        orden: 8,
        esMinimaEsperable: true,
    },
    resolucion_formula_cargos: {
        clase: 'resolucion_formula_cargos',
        nombre: 'Formula cargos a un inculpado',
        familia: 'fiscalia',
        etapaTypica: ['formulacion_cargos'],
        orden: 10,
        esMinimaEsperable: true,
    },
    resolucion_provee_escrito: {
        clase: 'resolucion_provee_escrito',
        nombre: 'Provee escrito de parte (resuelve incidencia)',
        familia: 'fiscalia',
        etapaTypica: ['instruccion', 'formulacion_cargos', 'descargos'],
        orden: 14,
    },
    resolucion_evacuados_descargos: {
        clase: 'resolucion_evacuados_descargos',
        nombre: 'Por evacuados los descargos → autos para vista fiscal',
        familia: 'fiscalia',
        etapaTypica: ['descargos'],
        orden: 11,
        esMinimaEsperable: true,
    },
    resolucion_termino_probatorio: {
        clase: 'resolucion_termino_probatorio',
        nombre: 'Abre / resuelve término probatorio',
        familia: 'fiscalia',
        etapaTypica: ['descargos'],
        orden: 12,
        esMinimaEsperable: true,
    },
    vista_fiscal: {
        clase: 'vista_fiscal',
        nombre: 'Vista fiscal',
        familia: 'fiscalia',
        etapaTypica: ['vista_fiscal'],
        orden: 15,
        esMinimaEsperable: true,
    },
    resolucion_cierra_procedimiento: {
        clase: 'resolucion_cierra_procedimiento',
        nombre: 'Cierra el procedimiento',
        familia: 'fiscalia',
        etapaTypica: ['cerrado'],
        orden: 18,
    },
    constancia_notificacion: {
        clase: 'constancia_notificacion',
        nombre: 'Constancia de notificación',
        familia: 'fiscalia',
        etapaTypica: ['creado', 'instruccion', 'formulacion_cargos', 'descargos', 'vista_fiscal'],
        orden: 2,
        esMinimaEsperable: true,
    },
    escrito_descargos: {
        clase: 'escrito_descargos',
        nombre: 'Evacúa descargos',
        familia: 'parte',
        etapaTypica: ['descargos'],
    },
    solicitud_recusacion: {
        clase: 'solicitud_recusacion',
        nombre: 'Recusa al fiscal o actuario',
        familia: 'parte',
        etapaTypica: ['instruccion'],
    },
    solicitud_nulidad: {
        clase: 'solicitud_nulidad',
        nombre: 'Solicita nulidad / deja sin efecto una actuación',
        familia: 'parte',
        etapaTypica: ['instruccion', 'formulacion_cargos', 'descargos'],
    },
    solicitud_aumento_plazo: {
        clase: 'solicitud_aumento_plazo',
        nombre: 'Solicita aumento de plazo para descargos',
        familia: 'parte',
        etapaTypica: ['descargos'],
    },
    solicitud_copia_expediente: {
        clase: 'solicitud_copia_expediente',
        nombre: 'Solicita copia del expediente sumarial',
        familia: 'parte',
        etapaTypica: ['descargos'],
    },
    correo_electronico: {
        clase: 'correo_electronico',
        nombre: 'Correo electrónico incorporado como antecedente',
        familia: 'anexo',
        etapaTypica: ['creado', 'instruccion', 'formulacion_cargos', 'descargos', 'vista_fiscal'],
    },
};
export function esClaseEscritoValida(valor) {
    return CLASES_ESCRITO.includes(valor);
}
const CLASES_EXTERNAS = new Set([
    // Actos administrativos de la autoridad
    'decreto_instruye_sumario',
    'acto_administrativo',
    // De terceros
    'formulario_denuncia',
    'correo_electronico',
    // Del inculpado / defensa
    'escrito_descargos',
    'solicitud_recusacion',
    'solicitud_nulidad',
    'solicitud_aumento_plazo',
    'solicitud_copia_expediente',
]);
export function ambitoDe(clase) {
    return CLASES_EXTERNAS.has(clase) ? 'externo' : 'interno';
}
export function esInterno(clase) {
    return ambitoDe(clase) === 'interno';
}
/** Clases producidas por la fiscalía (redactables en el sistema). */
export const CLASES_INTERNAS = CLASES_ESCRITO.filter((c) => esInterno(c));
/** Clases que se incorporan digitalizadas (autoridad, terceros, inculpado). */
export const CLASES_EXTERNAS_LISTA = CLASES_ESCRITO.filter((c) => !esInterno(c));
/**
 * Posición procesal canónica de una clase (ver `DefinicionClaseEscrito.orden`).
 * Las clases sin orden fijo caen al final (`Number.MAX_SAFE_INTEGER`) para no
 * intercalarse en la secuencia procesal al ordenar.
 */
export function ordenDeClase(clase) {
    return DEFINICION_CLASE_ESCRITO[clase].orden ?? Number.MAX_SAFE_INTEGER;
}
/** ¿La clase es una actuación mínima esperable del mapa procedimental canónico? */
export function esMinimaEsperable(clase) {
    return DEFINICION_CLASE_ESCRITO[clase].esMinimaEsperable === true;
}
/**
 * Comparador estable por orden procesal canónico. Empates (misma etapa) y
 * clases sin orden conservan el orden de definición de `CLASES_ESCRITO`.
 */
function porOrdenProcesal(a, b) {
    const da = ordenDeClase(a);
    const db = ordenDeClase(b);
    if (da !== db)
        return da - db;
    return CLASES_ESCRITO.indexOf(a) - CLASES_ESCRITO.indexOf(b);
}
/**
 * Clases internas ordenadas por secuencia procesal canónica (no por orden de
 * definición) — es lo que consume el selector de tipo de escrito.
 */
export const CLASES_INTERNAS_ORDENADAS = [...CLASES_INTERNAS].sort(porOrdenProcesal);
const CIERRE_BORRADOR = '[BORRADOR — estructura sin validación legal.]';
/** Firma estándar fiscal + actuario al pie de una resolución de fiscalía. */
const FIRMA_FISCALIA = ['{{ACTUARIO}}', 'ACTUARIO', '', '{{FISCAL}}', 'FISCAL'];
/**
 * Resolución de fiscalía (VISTOS Y CONSIDERANDO / RESUELVO). El `resuelve`
 * concreto es lo que distingue a cada tipo de escrito.
 */
function resolucionFiscalia(titulo, resuelve) {
    return [
        '{{ORGANISMO}}',
        '',
        titulo.toUpperCase(),
        '{{LUGAR}}, {{FECHA}}',
        '',
        'VISTOS Y CONSIDERANDO:',
        '',
        'PRIMERO: «antecedentes y fundamentos».',
        '',
        'RESUELVO:',
        '',
        ...resuelve,
        '',
        ...FIRMA_FISCALIA,
        '',
        CIERRE_BORRADOR,
    ].join('\n');
}
/**
 * RESUELVO específico por clase de resolución de fiscalía — lo que hace que
 * cada tipo de escrito tenga un esqueleto propio y no uno genérico. Solo
 * clases INTERNAS: los actos administrativos externos (p. ej. el decreto que
 * instruye) se incorporan digitalizados, no se redactan.
 */
const RESUELVE_POR_CLASE = {
    resolucion_acepta_cargo: [
        'ACEPTO Y JURO desempeñar fielmente el cargo con observancia del debido proceso.',
        'DESIGNO como actuario/a a «nombre».',
        'DESIGNO como lugar de la fiscalía «domicilio».',
        'DESIGNO el correo «correo» para la presentación de escritos y notificaciones.',
    ],
    resolucion_constituye_fiscalia: [
        'CONSTITÚYASE esta Fiscalía Instructora en «domicilio».',
        'DESÍGNASE actuario/a a «nombre».',
    ],
    resolucion_incorpora_antecedentes: [
        'INCORPÓRESE al expediente la siguiente documentación:',
        '- «antecedente 1».',
        '- «antecedente 2».',
    ],
    resolucion_solicita_antecedentes: [
        'REQUIÉRASE a «unidad interna» la siguiente información: «detalle».',
        'FÍJESE un plazo de «N» días hábiles para su entrega.',
    ],
    resolucion_solicita_oficio_externo: [
        'OFÍCIESE a «organismo externo (PDI / Contraloría / Superintendencia / COMPIN / etc.)»',
        'a fin de que informe/certifique «detalle del requerimiento».',
        'FÍJESE plazo para su respuesta.',
    ],
    resolucion_solicita_comparecencia: [
        'CÍTESE a declarar a «persona» para el día «fecha» a las «hora» hrs., en «domicilio de la fiscalía».',
        'APERCÍBASE conforme a los arts. 129 inc. 2° y 133 de la Ley 18.883 (arts. 131 y 119 y siguientes de la Ley 18.834).',
        'HÁGASE PRESENTE que el citado puede formular causales de recusación o implicancia en contra del',
        'fiscal o del actuario, las que deberán ingresarse por escrito (art. 131 Ley 18.883 / art. 134 Ley 18.834).',
        'NOTIFÍQUESE personalmente.',
    ],
    resolucion_suspension_preventiva: [
        'SUSPÉNDASE preventivamente de sus funciones a {{INCULPADO_NOMBRE}},',
        'como medida para resguardar la investigación.',
    ],
    resolucion_solicita_peritaje: [
        'ORDÉNASE la práctica de una pericia sobre «objeto», a fin de «finalidad».',
        'CONCÉDASE un plazo de «N» días hábiles.',
    ],
    resolucion_eleva_autos_recusacion: [
        'ELÉVENSE los autos a «autoridad» para que resuelva la recusación interpuesta.',
        'SUSPÉNDASE el procedimiento hasta su resolución.',
    ],
    resolucion_reapertura: ['REÁBRASE el procedimiento a fin de «motivo».'],
    resolucion_pide_acumular: [
        'SOLICÍTASE la acumulación de los autos «rol/decreto» al presente sumario,',
        'por versar sobre hechos relacionados.',
    ],
    resolucion_acumula_autos: [
        'ACUMÚLENSE al presente sumario los autos instruidos por «decreto/rol».',
    ],
    resolucion_incorpora_analisis_fiscalia: [
        'INCORPÓRESE el resumen y análisis de antecedentes elaborado por esta Fiscalía.',
    ],
    resolucion_cierra_instruccion: [
        'DECLÁRASE cerrada la etapa de instrucción.',
        'PROCÉDASE a formular cargos o dictar vista fiscal, según corresponda.',
    ],
    resolucion_sobreseimiento: [
        'SOBRESÉASE a {{INCULPADO_NOMBRE}}, por «causal (p. ej. cese de funciones, art. 153 b Ley 18.883)».',
    ],
    resolucion_formula_cargos: [
        'FORMÚLASE el siguiente cargo al/la funcionario/a «cargo/grado/calidad» (identificar por rol, no por nombre):',
        'PRIMER CARGO: «hecho imputado — qué se hizo, cuándo y en qué circunstancias, con referencia a los antecedentes que lo acreditan».',
        'Infracción legal estimada. En esta etapa, los hechos se estiman SUSCEPTIBLES de constituir infracción a:',
        "Letra «X») del artículo «XX» «Ley aplicable»: '«texto literal de la letra»'. «Cómo el hecho encaja en ese deber, en lenguaje presuntivo».",
        'Si se cita la letra g) (probidad), vincular con el numeral «N») del art. 62 de la Ley 18.575 que corresponda.',
        'La entidad, gravedad y la procedencia de una sanción se determinarán en la vista fiscal, a la luz de los descargos y la prueba.',
        'NOTIFÍQUESE; el inculpado dispone de cinco (5) días para presentar descargos, defensas y',
        'ofrecer pruebas, plazo prorrogable conforme al art. 136 de la Ley 18.883 (art. 138 Ley 18.834).',
        'APERCÍBASE que, de no evacuar descargos, se tendrán por evacuados en rebeldía y se proseguirá el sumario.',
        'ENTRÉGUESE copia digital del expediente para preparar la defensa.',
    ],
    resolucion_medidas_resguardo_karin: [
        'DISPÓNENSE las siguientes medidas de resguardo en favor de la persona denunciante (Ley 21.643):',
        '- «separación de espacios / cambio de turnos / redistribución de la jornada / atención psicológica, etc.».',
        'Las medidas son provisorias, no constituyen sanción y se mantendrán mientras dure la investigación.',
        'NOTIFÍQUESE.',
    ],
    resolucion_termino_probatorio: [
        'ÁBRESE un término probatorio de «N» días para rendir la prueba ofrecida en los descargos.',
        'TÉNGANSE por acompañados los documentos y por ofrecida la prueba testimonial/pericial que se indica.',
        'NOTIFÍQUESE.',
    ],
    resolucion_provee_escrito: ['TÉNGASE presente / provéase el escrito de «parte»: «resolución».'],
    resolucion_evacuados_descargos: [
        'TÉNGANSE por evacuados los descargos.',
        'AUTOS para preparar la vista fiscal.',
        'NOTIFÍQUESE.',
    ],
    resolucion_cierra_procedimiento: ['DECLÁRASE cerrado el procedimiento.', 'ARCHÍVESE.'],
};
/**
 * Devuelve un ESQUELETO de contenido con placeholders, PROPIO de cada clase de
 * escrito INTERNA (ver §3 del catálogo). Es andamiaje estructural — NO texto
 * jurídico validado; el fiscal completa las secciones «...» y el abogado valida
 * la redacción. Las `{{VARIABLES}}` se sustituyen con los datos del sumario
 * aguas abajo. Para clases externas devuelve '' (no se redactan).
 */
export function esqueletoEscrito(clase) {
    // Los externos no se redactan en el sistema (se incorporan digitalizados).
    if (!esInterno(clase))
        return '';
    const def = DEFINICION_CLASE_ESCRITO[clase];
    // Piezas internas fuera del molde estándar de resolución.
    switch (clase) {
        case 'informe_diligencia':
            return [
                `${def.nombre.toUpperCase()} N°«...»`,
                'En {{LUGAR}}, a {{FECHA}}, informo el resultado de la diligencia:',
                '- «gestión / hallazgo 1».',
                '- «gestión / hallazgo 2».',
                'CONCLUSIÓN: «...».',
                '',
                '{{FISCAL}} (o funcionario/perito informante)',
                '',
                CIERRE_BORRADOR,
            ].join('\n');
        case 'acta_declaracion':
            return [
                'ACTA DE DECLARACIÓN N°«...»',
                'En {{LUGAR}}, a {{FECHA}}, comparece «declarante», quien bajo promesa de decir verdad expone:',
                'PREGUNTADO/A: «...»  RESPONDE: «...».',
                'PREGUNTADO/A: «...»  RESPONDE: «...».',
                '',
                ...FIRMA_FISCALIA,
                '',
                CIERRE_BORRADOR,
            ].join('\n');
        case 'vista_fiscal':
            return [
                '{{ORGANISMO}}',
                '',
                'VISTA FISCAL',
                '{{LUGAR}}, {{FECHA}}',
                '',
                'VISTOS Y CONSIDERANDO:',
                '',
                'PRIMERO (hechos investigados): «relación circunstanciada de los hechos, con fechas, lugares y personas identificadas por su rol».',
                'SEGUNDO (prueba rendida): «documentos, declaraciones y pericias incorporadas y su ponderación (art. 137 Ley 18.883 / art. 137 Ley 18.834)».',
                'TERCERO (descargos): «síntesis de los descargos del/la funcionario/a y análisis de cada alegación».',
                '',
                '— Motivación del acto (art. 11 inc. 2° y art. 41 inc. 4° de la Ley 19.880): relación de hechos probados → norma infringida → razonamiento.',
                'CUARTO (hechos probados): «qué hechos se tienen por acreditados y con cuál prueba se acreditan».',
                'QUINTO (norma infringida y razonamiento): «deber u obligación / prohibición infringido, con cita de la letra y artículo»;',
                '  «razonamiento que conecta el hecho probado con la norma —de qué modo la conducta la vulnera—».',
                'SEXTO (calificación por cargo): respecto de cada cargo se concluye: «acreditado / acreditado con atenuantes / no acreditado / sobreseído».',
                '',
                '— Proporcionalidad de la sanción (gravedad, participación y circunstancias, art. 120 Ley 18.883 / art. 121 inc. 2° Ley 18.834).',
                'SÉPTIMO (gravedad y participación): «gravedad de la falta y grado de participación del/la funcionario/a en los hechos».',
                'OCTAVO (atenuantes y agravantes): «atenuantes (p. ej. conducta funcionaria anterior, irreprochable comportamiento) y agravantes que arroje el mérito de los antecedentes».',
                'NOVENO (adecuación de la medida): «por qué la sanción propuesta es la adecuada y no una más gravosa ni una más benigna».',
                '',
                'POR TANTO; este Fiscal Instructor propone:',
                'PROPONGO a {{AUTORIDAD}} aplicar a {{INCULPADO_NOMBRE}} la medida de «sanción (censura / multa % / suspensión / destitución)»,',
                'por haberse configurado el cargo; o bien el SOBRESEIMIENTO / la ABSOLUCIÓN de «...».',
                'NOTIFÍQUESE / ELÉVENSE los antecedentes.',
                '',
                '{{FISCAL}}',
                'FISCAL',
                '',
                CIERRE_BORRADOR,
            ].join('\n');
        case 'constancia_notificacion':
            return [
                'CONSTANCIA DE NOTIFICACIÓN',
                'En {{LUGAR}}, a {{FECHA}}, notifiqué a «persona» de «resolución N°...».',
                '',
                'Nombre: ______________________  RUN: ______________  Firma: ____________',
                '',
                CIERRE_BORRADOR,
            ].join('\n');
    }
    // Resoluciones de fiscalía con RESUELVO propio; si falta, uno genérico.
    const resuelve = RESUELVE_POR_CLASE[clase] ?? ['1. «lo que se resuelve».'];
    return resolucionFiscalia(def.nombre, resuelve);
}
/**
 * Cláusulas de fundamentación estándar, derivadas de la doctrina de motivación
 * del acto (art. 11 inc. 2° y 41 inc. 4° de la Ley 19.880: relación de hechos
 * probados → norma infringida → razonamiento) y de proporcionalidad de la
 * sanción (gravedad, participación y circunstancias, art. 120 Ley 18.883 /
 * art. 121 inc. 2° Ley 18.834). Solo se ofrecen para la vista fiscal y la
 * formulación de cargos; para el resto de clases devuelve [].
 *
 * Anonimizado: identifica al inculpado por su rol («el/la funcionario/a»),
 * nunca por nombre. El fiscal revisa y completa las secciones «...».
 */
export function clausulasSugeridas(clase) {
    if (clase === 'vista_fiscal') {
        return [
            {
                etiqueta: 'Motivación — hechos probados',
                texto: 'Que se tienen por acreditados los siguientes hechos: «...», sobre la base de «prueba: documentos / declaraciones / pericias», ponderada conforme al art. 137 de la Ley 18.883 (art. 137 Ley 18.834).',
            },
            {
                etiqueta: 'Motivación — norma infringida y razonamiento',
                texto: 'Que la conducta acreditada infringe «letra y artículo del deber u obligación / prohibición»; ello porque «razonamiento que conecta el hecho probado con la norma, explicitando de qué modo la conducta la vulnera». La expresión de estos fundamentos de hecho y de derecho satisface el deber de motivación del acto (art. 11 inc. 2° y art. 41 inc. 4° de la Ley 19.880).',
            },
            {
                etiqueta: 'Proporcionalidad — gravedad y participación',
                texto: 'Que, para graduar la medida, se considera la gravedad de la falta y el grado de participación del/la funcionario/a en los hechos, de modo que la sanción guarde correspondencia con la entidad de la infracción (art. 120 Ley 18.883 / art. 121 inc. 2° Ley 18.834).',
            },
            {
                etiqueta: 'Proporcionalidad — atenuantes y agravantes',
                texto: 'Que concurren las siguientes circunstancias atenuantes: «p. ej. conducta funcionaria anterior / irreprochable comportamiento / colaboración»; y agravantes: «...», según el mérito de los antecedentes, las que se ponderan para determinar la medida a proponer.',
            },
        ];
    }
    if (clase === 'resolucion_formula_cargos') {
        // Estructura recomendable de un cargo (deber → conducta → prohibición →
        // probidad → resultado → imputación subjetiva → responsabilidad).
        return [
            {
                etiqueta: 'Hecho imputado (presuntivo)',
                texto: 'Que de los antecedentes reunidos aparecen presunciones fundadas de que el/la funcionario/a «cargo/grado» habría «descripción del hecho: qué se hizo u omitió, cuándo, dónde y en qué calidad», según da cuenta «antecedente que lo sustenta» (art. 133 inc. 3° Ley 18.883).',
            },
            {
                etiqueta: 'Deber funcional específico infringido',
                texto: 'Que dicha conducta sería susceptible de infringir «letra y artículo del deber»: art. 58 Ley 18.883 / art. 61 Ley 18.834; de acreditarse, «de qué modo el hecho vulneraría ese deber, en lenguaje presuntivo».',
            },
            {
                etiqueta: 'Deber especial de jefatura (si aplica)',
                texto: 'Que, además, la conducta comprometería el deber especial de control jerárquico de la jefatura (art. 61 Ley 18.883 / art. 64 Ley 18.834; art. 11 Ley 18.575) por «falta de supervisión / tolerancia de irregularidades conocidas / ausencia de control». La responsabilidad de la jefatura no sustituye la del subordinado: cada uno infringe un deber distinto.',
            },
            {
                etiqueta: 'Prohibición infringida (si aplica)',
                texto: 'Que la conducta también sería susceptible de constituir infracción a la prohibición del «letra y artículo»: art. 82 Ley 18.883 / art. 84 Ley 18.834.',
            },
            {
                etiqueta: 'Probidad (vínculo art. 62 Ley 18.575)',
                texto: 'Que, al invocarse la probidad (art. 58 g Ley 18.883 / art. 61 g Ley 18.834; arts. 52 y 53 Ley 18.575), se especifica el numeral del art. 62 de la Ley 18.575 que se configuraría —«numeral N»— y por qué la infracción reviste gravedad suficiente. No basta la mención genérica de «falta a la probidad».',
            },
            {
                etiqueta: 'Resultado o efecto',
                texto: 'Que la conducta habría producido «detrimento / retraso / riesgo / afectación del servicio / uso indebido de recursos / entorpecimiento de derechos de los ciudadanos».',
            },
            {
                etiqueta: 'Imputación subjetiva',
                texto: 'Que la conducta sería atribuible a título de «dolo / negligencia / inexcusable descuido / tolerancia o falta de control», sin perjuicio de lo que resulte de los descargos y la prueba.',
            },
            {
                etiqueta: 'Responsabilidad administrativa',
                texto: 'Que los hechos, de acreditarse, harían nacer responsabilidad administrativa (art. 118 Ley 18.883 / art. 119 Ley 18.834), independiente de la civil y penal.',
            },
        ];
    }
    return [];
}
//# sourceMappingURL=escritos.js.map